import { ProviderEvents, ProviderStatus } from '@openfeature/web-sdk';

import type { FeatureFlagBridge } from './featureFlagClient.types';
import { getFeatureFlagClient } from './providerRegistry';

export const featureFlagClient: FeatureFlagBridge = {
  getBooleanValue: (key, defaultValue, options) => {
    return getFeatureFlagClient(options?.provider).getBooleanValue(key, defaultValue);
  },
  getBooleanDetails: (key, defaultValue, options) => {
    return getFeatureFlagClient(options?.provider).getBooleanDetails(key, defaultValue);
  },
  getStringValue: (key, defaultValue, options) => {
    return getFeatureFlagClient(options?.provider).getStringValue(key, defaultValue);
  },
  getNumberValue: (key, defaultValue, options) => {
    return getFeatureFlagClient(options?.provider).getNumberValue(key, defaultValue);
  },
  onChange: (callback, options) => {
    const targetClient = getFeatureFlagClient(options?.provider);
    const handler = (): void => {
      callback();
    };

    targetClient.addHandler(ProviderEvents.Ready, handler);
    targetClient.addHandler(ProviderEvents.ConfigurationChanged, handler);
    targetClient.addHandler(ProviderEvents.ContextChanged, handler);

    return (): void => {
      targetClient.removeHandler(ProviderEvents.Ready, handler);
      targetClient.removeHandler(ProviderEvents.ConfigurationChanged, handler);
      targetClient.removeHandler(ProviderEvents.ContextChanged, handler);
    };
  },
  isReady: (options) => {
    return getFeatureFlagClient(options?.provider).providerStatus === ProviderStatus.READY;
  },
};
